import React from "react";

class Home extends React.Component<{}, {}> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {
    }

    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (<React.Fragment>

            <div className="container  min-vh-100 ">
                <div className="row responsive-p">
                    <div className={"col-12 pb-4"}>
                        <h1 className={"text-center pt-4 verlag-light"}>
                            <img src={"https://storage.googleapis.com/streamline-bucket/FullNoBackground.png"}
                                className={"homepage-logo"}
                                alt={"logo"}/>
                        </h1>
                        <h1 className="text-center verlag-light text-uppercase font-weight-bold">High-Speed Testing Service</h1>
                    </div>
                    <div className="col-xl-4 pt-2 pb-2 text-center verlag-light responsive-p">
                        <a href="/appointment">
                        <img className="img-fluid text-center homeIcon" src={"https://storage.googleapis.com/streamline-bucket/makeAppointment.png"} alt=""
                             />
                        </a>
                            <h1 className="verlag-light">Make Appointment</h1>

                    </div>
                    <div className="col-xl-4 pt-2 pb-2 text-center">
                        <a href="/appointment">
                        <img className="img-fluid text-center homeIcon" src={"https://storage.googleapis.com/streamline-bucket/getTested.png"} alt=""
                            />
                        </a>
                            <h1 className="verlag-light">Get Tested</h1>
                    </div>
                    <div className="col-xl-4 pt-2 pb-2  text-center">
                        <a href={"/results"}>
                        <img className="img-fluid text-center homeIcon" src={"https://storage.googleapis.com/streamline-bucket/results.png"} alt=""
                             />
                        </a>
                            <h1 className="verlag-light">Get Results Digitally</h1>
                    </div>
                    <div className={"col-12 pb-4 bt-4 text-center"} style={{fontSize:".8em"}}>
                        <p>With the end of the public health emergency declaration, IMMYLabs discontinued our COVID-19 & flu testing operations as of July 27th, 2023.  Patients seeking testing services are encouraged to contact their county health department or physician for testing services after 7/27/2023.</p>
                        <a href="https://oklahoma.gov/health/locations/county-health-departments/oklahoma-county-health-departments-reference-guide.html">Click Here for a list of Oklahoma State County Health Departments.</a>
                        <p>Thank you for your trust in our services and commitment to public safety alongside the last three years.</p>
                    </div>
                    {/* <div className={"col-12 pb-4 pt-4 text-center responsive-p"}>
                        <p className={"verlag-light "}>Schedule your Combined Covid-19/Influenza test today.</p>
                        <a href={"/appointment"}> <button className="btn btn-primary">Make Appointment</button></a>
                    </div> */}
                </div>
            </div>
        </React.Fragment>)
    }
}
export default Home;